module.exports = __webpack_public_path__ + "static/media/checkatrade-verified.d402a508.png";